import React from 'react'
import { Choose1Svg, Choose2Svg, Choose3Svg, Choose4Svg, Choose5Svg, Choose6Svg } from '../svg'
import SplitText from "../../../common/SplitText";

export default function WhyChoose() {
    return (
        <div className='mt-[80px] sm:mt-[100px] bg-[#FFF8FB] px-[16px] sm:px-[24px] lg:px-[40px] py-[50px] sm:py-[80px] lg:py-[100px] text-center'>
            <SplitText
                text="Why Choose Rainbow Trucks?"
                tag="h2"
                className='text-[#0F0200] font-bold text-[30px] sm:text-[40px] lg:text-[50px] xl:text-[58px]'
                delay={30}
                duration={0.6}
                ease="power3.out"
                splitType="words, chars"
                from={{ opacity: 0, y: 30 }}
                to={{ opacity: 1, y: 0 }}
                threshold={0.1}
                rootMargin="-40px"
                textAlign="center"
            />
            <div className='w-11/12 max-w-[1360px] mx-auto mt-[36px] lg:mt-[50px] grid sm:grid-cols-2 lg:grid-cols-3 gap-[20px] lg:gap-[24px]'>
                
                <div className='p-[28px] lg:p-[32px] bg-[#FFFFFF] rounded-[24px] border border-gray-100 shadow-card hover:shadow-card-hover hover:-translate-y-1.5 transition-all duration-300 flex flex-col gap-[18px] items-start text-left'>
                    <div className='p-3 bg-pink-50 rounded-2xl'>
                        <Choose1Svg />
                    </div>
                    <h3 className='text-[#181F38] text-[20px] lg:text-[24px] font-bold'>A Successful Business Model</h3>
                    <p className='text-[#5A6656] text-[15px] lg:text-[16px] font-normal leading-relaxed'>Rainbow Trucks has been a hit in Tamil Nadu, serving delicious, handmade kulfi from mobile carts. The business is scalable and easy to replicate, making it ideal for new franchisees.</p>
                </div>

                <div className='p-[28px] lg:p-[32px] bg-[#FFFFFF] rounded-[24px] border border-gray-100 shadow-card hover:shadow-card-hover hover:-translate-y-1.5 transition-all duration-300 flex flex-col gap-[18px] items-start text-left'>
                    <div className='p-3 bg-purple-50 rounded-2xl'>
                        <Choose2Svg />
                    </div>
                    <h3 className='text-[#181F38] text-[20px] lg:text-[24px] font-bold'>Low Investment, High Profit</h3>
                    <p className='text-[#5A6656] text-[15px] lg:text-[16px] font-normal leading-relaxed'>With affordable cart options starting at ₹3 Lakhs, and with kulfi sold at ₹50 each, franchisees can earn impressive returns and quick payback.</p>
                </div>

                <div className='p-[28px] lg:p-[32px] bg-[#FFFFFF] rounded-[24px] border border-gray-100 shadow-card hover:shadow-card-hover hover:-translate-y-1.5 transition-all duration-300 flex flex-col gap-[18px] items-start text-left'>
                    <div className='p-3 bg-emerald-50 rounded-2xl'>
                        <Choose3Svg />
                    </div>
                    <h3 className='text-[#181F38] text-[20px] lg:text-[24px] font-bold'>Complete Franchise Support</h3>
                    <p className='text-[#5A6656] text-[15px] lg:text-[16px] font-normal leading-relaxed'>From day one, franchisees receive all the training and tools they need to succeed. Ongoing support from marketing to product supply ensures smooth operations.</p>
                </div>

                <div className='p-[28px] lg:p-[32px] bg-[#FFFFFF] rounded-[24px] border border-gray-100 shadow-card hover:shadow-card-hover hover:-translate-y-1.5 transition-all duration-300 flex flex-col gap-[18px] items-start text-left'>
                    <div className='p-3 bg-rose-50 rounded-2xl'>
                        <Choose4Svg />
                    </div>
                    <h3 className='text-[#181F38] text-[20px] lg:text-[24px] font-bold'>In-Demand Product</h3>
                    <p className='text-[#5A6656] text-[15px] lg:text-[16px] font-normal leading-relaxed'>Rainbow Trucks - Fresh Kulfi is a popular, evergreen dessert enjoyed across India. With increasing demand, this business offers lasting growth opportunities.</p>
                </div>

                <div className='p-[28px] lg:p-[32px] bg-[#FFFFFF] rounded-[24px] border border-gray-100 shadow-card hover:shadow-card-hover hover:-translate-y-1.5 transition-all duration-300 flex flex-col gap-[18px] items-start text-left'>
                    <div className='p-3 bg-amber-50 rounded-2xl'>
                        <Choose5Svg />
                    </div>
                    <h3 className='text-[#181F38] text-[20px] lg:text-[24px] font-bold'>Income Flexibility</h3>
                    <p className='text-[#5A6656] text-[15px] lg:text-[16px] font-normal leading-relaxed'>Whether as a primary income stream or a secondary income to supplement family needs, Rainbow Trucks provides a viable, profitable business model.</p>
                </div>

                <div className='p-[28px] lg:p-[32px] bg-[#FFFFFF] rounded-[24px] border border-gray-100 shadow-card hover:shadow-card-hover hover:-translate-y-1.5 transition-all duration-300 flex flex-col gap-[18px] items-start text-left'>
                    <div className='p-3 bg-teal-50 rounded-2xl'>
                        <Choose6Svg />
                    </div>
                    <h3 className='text-[#181F38] text-[20px] lg:text-[24px] font-bold'>Steady Passive Income</h3>
                    <p className='text-[#5A6656] text-[15px] lg:text-[16px] font-normal leading-relaxed'>Looking for a business that can run with minimal intervention and generate steady income? Rainbow Trucks provides an excellent opportunity for scalable passive growth.</p>
                </div>
            </div>
        </div>
    )
}
